import React from "react";
/** Components Import */

function MultiCombo({
	containerStyle,
	optionStyle,
	combos = [],
	value = [],
	onChange,
	selected = [],
}) {
	const ComboChange = (e) => {
		onChange(e.target.value);
	};

	return (
		<div className="input_set">
			<label>{selected.join()}</label>
			<select
				className="combo_container"
				style={containerStyle}
				onChange={ComboChange}
				value={value}
				required
				multiple
			>
				{combos.map((item, index) => {
					return (
						<option
							className="combo_option"
							style={optionStyle}
							key={index}
							value={item.value}
							disabled={item.disabled}
						>
							{item.name}
						</option>
					);
				})}
			</select>
		</div>
	);
}

MultiCombo.defaultProps = {};

export default MultiCombo;
